import React from 'react';
import { FaCalendarAlt } from 'react-icons/fa';

const AdminReportsTab = ({ monthlyReport }) => (
  <div className="space-y-6">
    <h2 className="text-xl font-bold text-white">Monthly Report</h2>

    {monthlyReport && (
      <>
        <div className="bg-gradient-to-br from-[#1A2942] to-[#1E3A5F] rounded-xl p-6 border border-[#2D5A8F]">
          <h3 className="text-lg font-bold text-[#FFD700] mb-4">
            <FaCalendarAlt className="inline mr-2" /> Period: {monthlyReport.period}
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="bg-[#0F172A] rounded-lg p-4">
              <p className="text-gray-400 text-sm">New Clients</p>
              <p className="text-2xl font-bold text-[#FFD700]">{monthlyReport.metrics.new_clients}</p>
            </div>
            <div className="bg-[#0F172A] rounded-lg p-4">
              <p className="text-gray-400 text-sm">New Advisors</p>
              <p className="text-2xl font-bold text-blue-400">{monthlyReport.metrics.new_advisors}</p>
            </div>
            <div className="bg-[#0F172A] rounded-lg p-4">
              <p className="text-gray-400 text-sm">New Plans</p>
              <p className="text-2xl font-bold text-green-400">{monthlyReport.metrics.new_plans}</p>
            </div>
            <div className="bg-[#0F172A] rounded-lg p-4">
              <p className="text-gray-400 text-sm">Top-Ups Approved</p>
              <p className="text-2xl font-bold text-purple-400">{monthlyReport.metrics.topup_approved}</p>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-[#1A2942] to-[#1E3A5F] rounded-xl p-6 border border-[#2D5A8F]">
          <h3 className="text-lg font-bold text-white mb-4">Top Advisors by Clients</h3>
          <div className="space-y-3">
            {monthlyReport.top_advisors?.slice(0, 5).map((advisor, idx) => (
              <div key={idx} className="flex items-center justify-between bg-[#0F172A] rounded-lg p-3">
                <div className="flex items-center space-x-3">
                  <span className="text-[#FFD700] font-bold">#{idx + 1}</span>
                  <span className="text-white">{advisor.name}</span>
                </div>
                <span className="text-gray-400">{advisor.clients} clients</span>
              </div>
            ))}
          </div>
        </div>
      </>
    )}
  </div>
);

export default AdminReportsTab;
